module.exports = __webpack_public_path__ + "img/sycret.f436e3d4.png";